import { DismissFlash, ShowFlash } from 'ng2/shared/flash/store/flash.actions';

module.exports = {
  templateUrl: 'signin/components/login/login.html',
  bindings: {
    mode: '@',
  },
  controller: class LoginController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$session',
      '$state',
      'RegistrationService',
      'SecurityService',
    ];

    authError = false;

    constructor(
      $ngRedux,
      $scope,
      $session,
      $state,
      RegistrationService,
      SecurityService,
    ) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$session = $session;
      this.$state = $state;
      this.RegistrationService = RegistrationService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.mode = this.mode || 'patient';

      if (this.$state.params.error) {
        switch (this.$state.params.error) {
          case 'invalid_token':
            this.authError = 'invalid_token';
            break;
          case 'patient_not_created':
            this.authError = 'patient_not_created';
            break;
          default:
        }
      }

      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        clinic: state.group,
        isHospitalBooking: state.hospitalBooking.isHospitalBooking,
      }))(this));

      if (this.mode === 'kiosk') {
        this.title = 'kiosk.login_title';
      } else if (this.isHospitalBooking) {
        this.title = 'login.hospital_booking_title';
      } else {
        this.title = 'login.title';
      }

      if (this.RegistrationService.registrationEmail) {
        this.email = this.RegistrationService.registrationEmail;
      }
      if (this.RegistrationService.maskedEmail) {
        this.maskedEmail = this.RegistrationService.maskedEmail;
      }

      this.$ngRedux.dispatch(new DismissFlash());

      if (this.$state.params.confirmNewEmailState === 'success') {
        this.$session.reset();
        this.SecurityService.logout();

        this.$ngRedux.dispatch(new ShowFlash({ name: 'info', additionalInfos: { title: 'update.email.banner.success' } }));
      } else if (this.$state.params.confirmNewEmailState === 'error') {
        if (this.$state.params.alreadyConfirmed === 'true') {
          this.$ngRedux.dispatch(new ShowFlash({ name: 'info', additionalInfos: { title: 'update.email.banner.errorAlreadyConfirmed' } }));
        } else {
          this.$ngRedux.dispatch(new ShowFlash({ name: 'info', additionalInfos: { title: 'update.email.banner.error' } }));
        }
      }
    }

    submit() {
      this.authError = false;
      this.submitting = true;

      this.SecurityService.authenticate(this.email, this.password, this.mode === 'kiosk').then(this.authCallback.bind(this));
    }

    authCallback = (response) => {
      if (response.error) {
        this.submitting = false;

        if (response.error === 'authentication_failed') {
          this.authError = 'authentication_failed';
        } else if (response.error === 'patient_not_created') {
          this.authError = 'patient_not_created';
        }
      } else if (this.mode === 'kiosk') {
        this.$state.go('kiosk.home');
      } else {
        this.$state.go('patients.id.home', { patientId: response.session.id, token: null }, { reload: true });
      }
    };

    accountAuthCallback(response) {
      this.$state.go('kiosk.home', { patientId: response.session.id }, { reload: true });
    }

    states() {
      return this.RegistrationService.states.register;
    }

    clinics() {
      return this.RegistrationService.clinics;
    }

    canSubmit() {
      return this.RegistrationService.canSubmit(this.form);
    }

    hasErrors(ngModel) {
      return this.form && this.form.$submitted && this.RegistrationService.hasErrors(ngModel);
    }

    register() {
      return this.$state.go('register', this.$state.params);
    }

    forgotPassword() {
      return this.$state.go('forgotten_password', this.$state.params);
    }
  },
};



// WEBPACK FOOTER //
// ./signin/components/login/login.js